import React from "react";
import SunnhetUndersoekelser from "./SunnhetUndersoekelser";
import qs from "query-string";
import {withRouter, useHistory } from "react-router-dom";

const Sunnhet = (props) => {
    const oeyeEcvoUndersoekelser = props.oeyeEcvoUndersoekelser;
    const roentgenUndersoekelser = props.roentgenUndersoekelser;
    const oeyeDnaUndersoekelser = props.oeyeDnaUndersoekelser;
    const dnaUndersoekelser = props.dnaUndersoekelser
    const oevrigeUndersoekelser = props.oevrigeUndersoekelser;

    let history = useHistory();
    const parsed = qs.parse(decodeURI(props.location.search));
    let label = 'roentgen';
    if (parsed.sundhedLabel !== undefined) {
        label = parsed.sundhedLabel;
    }
    const getClassNames = (t) => {
        return (label === t)
            ? "tabs-title tab-active"
            : "tabs-title";
    };

    const show = (t) => {
        if (label === t) {
            return true;
        }
        return false;

    };

    const setLabel = (t) => {
        let params = parsed
        if (t !== label) {
            params.sundhedLabel = t;
        }
        delete params.stamLabel;
        delete params.query;
        delete params.antall;
        const currentPath = props.location.pathname;
        history.push(currentPath + "?" + qs.stringify(params));
    };


    return (
        <div>
            <div className="tab-container">
                <ul className="tree-options">
                    <li className={getClassNames('roentgen')} onClick={() => setLabel("roentgen")}>
                        <span>Røntgen</span>
                    </li>
                    <li className={getClassNames('oeye')} onClick={() => setLabel("oeye")}>
                        <span>Øjne</span>
                    </li>
                    <li className={getClassNames('oeye-dna')} onClick={() => setLabel("oeye-dna")}>
                        <span>Øjne DNA</span>
                    </li>
                    <li className={getClassNames('dna')} onClick={() => setLabel("dna")}>
                        <span>DNA</span>
                    </li>
                    <li className={getClassNames('oevrige')} onClick={() => setLabel("oevrige")}>
                        <span>Øvrige</span>
                    </li>
                </ul>
            </div>
            <div className="tabs-panel is-active" >
                {
                    show('roentgen') &&
                        <SunnhetUndersoekelser undersoekelser={roentgenUndersoekelser} />
                }
                {
                    show('oeye') &&
                        <SunnhetUndersoekelser undersoekelser={oeyeEcvoUndersoekelser} />
                }

                {
                    show('oeye-dna') &&
                        <SunnhetUndersoekelser undersoekelser={oeyeDnaUndersoekelser} />
                }
                {
                    show('dna') &&
                        <SunnhetUndersoekelser undersoekelser={dnaUndersoekelser} />
                }
                {
                    show('oevrige') &&
                        <SunnhetUndersoekelser undersoekelser={oevrigeUndersoekelser} />
                }

            </div>
        </div>
    );

};
export default withRouter (Sunnhet);
